<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        title="Home"
        @back="$router.push('/home').catch(() => {})"
        :content="$t('cadastro-servicos')"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-row type="flex" justify="end">
        <el-col :xs="24" :sm="6" :md="6" :lg="3" :xl="3">
          <el-switch v-model="inactive"></el-switch>&nbsp;
          <span>Mostrar inativos</span>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <el-input
            :placeholder="$t('pesquisar')"
            prefix-icon="el-icon-search"
            v-model="filter"
          ></el-input>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          <el-button
            class="right"
            type="primary"
            icon="el-icon-plus"
            @click="add()"
            >{{ $t("adicionar") }}</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="
          list.filter(
            (data) =>
              !filter ||
              data.name.toLowerCase().includes(filter.toLowerCase()) ||
              data.servicegroup.toLowerCase().includes(filter.toLowerCase()) ||
              data.code.toLowerCase().includes(filter.toLowerCase())
          )
        "
        stripe
        style="width: 100%"
        :default-sort="{ prop: 'name', order: 'ascending' }"
      >
        <el-table-column
          sortable
          prop="servicegroup"
          :label="$t('grupo-servico')"
          :filters="filterColumn('servicegroup')"
          :filter-method="filterHandler"
        >
        </el-table-column>
        <el-table-column
          sortable
          width="100px"
          prop="code"
          :label="$t('codigo')"
        ></el-table-column>
        <el-table-column
          sortable
          prop="name"
          :label="$t('nome')"
        ></el-table-column>
        <el-table-column sortable prop="postoffice" :label="$t('correio')">
          <template slot-scope="scope">{{
            scope.row.postoffice ? $t("sim") : $t("nao")
          }}</template>
        </el-table-column>
        <el-table-column label="#" width="180">
          <template slot-scope="scope">
            <el-button
              type="info"
              icon="el-icon-edit"
              @click="editar(scope.row.id)"
              circle
            ></el-button>
            <el-button
              v-if="scope.row.postoffice && scope.row.active"
              type="warning"
              icon="el-icon-close"
              @click="inactived(scope.row.id, scope.row.name)"
              circle
            ></el-button>
            <el-button
              v-if="scope.row.postoffice && scope.row.active === false"
              type="primary"
              icon="el-icon-check"
              @click="actived(scope.row.id, scope.row.name)"
              circle
            ></el-button>
            <el-button
              v-if="!scope.row.postoffice"
              type="danger"
              icon="el-icon-delete"
              @click="remove(scope.row.id, scope.row.name)"
              circle
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { ServicesService } from "@/services/customers/services.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "Services",
  methods: {
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      ServicesService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    add() {
      var vm = this;
      vm.$router.push("/cadastro/servico/adicionar").catch(() => {});
    },
    editar: function (id) {
      this.$router.replace({
        name: "services.edit",
        params: { id: id },
      });
    },
    remove: function (id, name) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-servico", { id: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading({
          lock: true,
          text: i18n.tc("carregando"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        ServicesService.delete(id)
          .then((response) => {
            setTimeout(() => {
              vm.fetchRecords();
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("servico-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            vm.$notify.error({
              title: i18n.tc("erro"),
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
    inactived: function (id, name) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-desativacao-servico", { id: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading({
          lock: true,
          text: i18n.tc("carregando"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        ServicesService.inactive(id)
          .then((response) => {
            setTimeout(() => {
              vm.fetchRecords();
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("servico-desativado-sucesso"),
            });
          })
          .catch((error) => {
            vm.$notify.error({
              title: i18n.tc("erro"),
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
    actived: function (id, name) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-ativacao-servico", { id: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading({
          lock: true,
          text: i18n.tc("carregando"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        ServicesService.active(id)
          .then((response) => {
            setTimeout(() => {
              vm.fetchRecords();
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("servico-ativado-sucesso"),
            });
          })
          .catch((error) => {
            vm.$notify.error({
              title: i18n.tc("erro"),
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
    filterColumn(column) {
      const vm = this;
      const list = [];
      for (const row of vm.tableData) {
        if (!list.find((x) => x.value === row[column])) {
          list.push({
            text: row[column],
            value: row[column],
          });
        }
      }
      list.sort(function (a, b) {
        if (a.text > b.text) return 1;
        if (a.text < b.text) return -1;
        return 0;
      });
      return list;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },
  computed: {
    list() {
      const vm = this;
      if (vm.inactive) {
        return vm.tableData;
      }
      return vm.tableData.filter((x) => x.active === true);
    },
  },
  data() {
    return {
      filter: "",
      inactive: false,
      tableData: [],
    };
  },
};
</script>
<style>
.right {
  float: right;
}
</style>